module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2018-19.32d8a8c4.pdf";